import React from "react";
import { Button, Flex, Text } from "@chakra-ui/react";
import SVG from "react-inlinesvg";

interface Props {
  onClick?: () => void;
}

function MyPageEditButton({ onClick }: Props) {
  return (
    <Button
      height={"20px"}
      variant={"ghost"}
      _hover={{ bg: "transparent" }}
      onClick={onClick}
    >
      <Flex gap={"4px"} alignItems={"center"}>
        <SVG src={"/icons-v1_1/edit.svg"} width={16} height={16} />
        <Text textStyle={"body-sm-bold"}>관리</Text>
      </Flex>
    </Button>
  );
}

export default MyPageEditButton;
